<template>
  <svg
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 10.6299H14C14 11.4255 13.6839 12.1886 13.1213 12.7512C12.5587 13.3138 11.7956 13.6299 11 13.6299H5C4.20435 13.6299 3.44129 13.3138 2.87868 12.7512C2.31607 12.1886 2 11.4255 2 10.6299Z"
      stroke="currentColor"
      stroke-width="1.27"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99998 2.37988C10.8372 2.37988 13.2147 3.97963 13.8395 6.12988H2.16048C2.78523 3.97963 5.16273 2.37988 7.99998 2.37988Z"
      stroke="currentColor"
      stroke-width="1.27"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75 8.37988H13.25"
      stroke="currentColor"
      stroke-width="1.27"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
